export default "__VITE_ASSET__Df7GC_gM__"